<span class="reportable-receipts-title label-medium-emphasized">
  Elenco brogliacci da versare
</span>

@if (isLoading) {
  <ui-loading-spinner></ui-loading-spinner>
}

<div class="reportable-receipts-desktop">
  <span class="title-medium-emphasized">Elenco brogliacci da versare</span>

  <div class="reportable-receipts-table-container">
    <table
      mat-table
      [dataSource]="brogliacciAssociabili"
      class="reportable-receipts-table"
    >
      <ng-container matColumnDef="numeroBrogliaccio">
        <th mat-header-cell *matHeaderCellDef>N. brogliaccio</th>
        <td mat-cell *matCellDef="let brogliaccio">{{ brogliaccio.numeroBrogliaccio }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="data">
        <th mat-header-cell *matHeaderCellDef>Data</th>
        <td mat-cell *matCellDef="let brogliaccio">
          {{ brogliaccio.data | date:'dd/MM/yyyy' }}
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span class="body-medium-emphasized">TOTALI</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="numeroIncassi">
        <th mat-header-cell *matHeaderCellDef>Incassi</th>
        <td mat-cell *matCellDef="let brogliaccio">{{ brogliaccio.numeroIncassi }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="importoContanti">
        <th mat-header-cell *matHeaderCellDef>Contanti</th>
        <td mat-cell *matCellDef="let brogliaccio" class="currency-cell">
          {{ brogliaccio.importoContanti | currency:'EUR':'symbol':'1.2-2' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="currency-cell">
          <span class="body-medium-emphasized">
            {{ totaleContantiSelezionati | currency:'EUR':'symbol':'1.2-2' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="importoAssegni">
        <th mat-header-cell *matHeaderCellDef>Assegni</th>
        <td mat-cell *matCellDef="let brogliaccio" class="currency-cell">
          {{ brogliaccio.importoAssegni | currency:'EUR':'symbol':'1.2-2' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="currency-cell">
          <span class="body-medium-emphasized">
            {{ totaleAssegniSelezionati | currency:'EUR':'symbol':'1.2-2' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="importoTotale">
        <th mat-header-cell *matHeaderCellDef>Totale</th>
        <td mat-cell *matCellDef="let brogliaccio" class="currency-cell">
          {{ brogliaccio.importoTotale | currency:'EUR':'symbol':'1.2-2' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="currency-cell">
          <span class="body-medium-emphasized">
            {{ totaleBrogliacciSelezionati | currency:'EUR':'symbol':'1.2-2' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="selezionato">
        <th mat-header-cell *matHeaderCellDef class="checkbox-cell">
          <mat-checkbox
            [checked]="tuttiInclusi"
            [indeterminate]="selezioneParziale"
            aria-label="Includi tutti i brogliacci"
            (change)="impostaTuttiInclusi($event.checked)"
          />
        </th>
        <td mat-cell *matCellDef="let brogliaccio" class="checkbox-cell">
          <mat-checkbox
            [checked]="brogliaccio.selezionato"
            [attr.aria-label]="'Includi brogliaccio ' + brogliaccio.numeroBrogliaccio"
            (change)="impostaBrogliaccioIncluso(brogliaccio.id, $event.checked)"
          />
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colonneTabella"></tr>
      <tr mat-row *matRowDef="let row; columns: colonneTabella"></tr>
      <tr mat-footer-row *matFooterRowDef="colonneTabella"></tr>
    </table>
  </div>

  <div class="desktop-draft-actions">
    <button
      matButton="filled"
      type="button"
      class="desktop-action-button desktop-action-button--wide"
      *uiCan="CAPS.distintaCrea"
      [disabled]="!almenoUnBrogliaccioIncluso || isSaving"
      (click)="creaDistinta()"
    >
      Crea distinta
    </button>

    <button
      matButton="outlined"
      type="button"
      class="desktop-action-button desktop-action-button--exit"
      (click)="tornaIndietro()"
    >
      Esci
    </button>
  </div>
</div>

<div class="reportable-receipts-content">
  <div class="include-all-row">
    <div class="include-all-checkbox-container">
      <mat-checkbox
        class="include-all-checkbox"
        [checked]="tuttiInclusi"
        [indeterminate]="selezioneParziale"
        (change)="impostaTuttiInclusi($event.checked)"
      >
        Includi tutti
      </mat-checkbox>
    </div>
  </div>

  <div class="reportable-receipts-list">
    @for (brogliaccio of brogliacciAssociabili; track brogliaccio.id) {
      <div class="reportable-receipt-card">
        <div class="reportable-receipt-data">
          <div class="receipt-checkbox-container">
            <mat-checkbox
              [checked]="brogliaccio.selezionato"
              [attr.aria-label]="'Includi brogliaccio ' + brogliaccio.numeroBrogliaccio"
              (change)="impostaBrogliaccioIncluso(brogliaccio.id, $event.checked)"
            />
          </div>
          <div class="reportable-receipt-info">
            <div class="receipt-info-first-row">
              <div class="receipt-info-pair">
                <span class="body-small">N. brogliaccio:</span>
                <span class="body-medium-emphasized">{{ brogliaccio.numeroBrogliaccio }}</span>
              </div>

              <div class="receipt-info-pair">
                <span class="body-small">Incassi:</span>
                <span class="body-medium-emphasized">{{ brogliaccio.numeroIncassi }}</span>
              </div>
            </div>

            <div class="receipt-info-row">
              <span class="body-small">Data:</span>
              <span class="body-medium-emphasized">
                {{ brogliaccio.data | date:'dd/MM/yyyy' }}
              </span>
            </div>

            <div class="receipt-info-row">
              <span class="body-small">Contanti:</span>
              <span class="body-medium-emphasized">
                {{ brogliaccio.importoContanti | currency:'EUR':'symbol':'1.2-2' }}
              </span>
            </div>

            <div class="receipt-info-row">
              <span class="body-small">Assegni:</span>
              <span class="body-medium-emphasized">
                {{ brogliaccio.importoAssegni | currency:'EUR':'symbol':'1.2-2' }}
              </span>
            </div>

            <div class="receipt-info-row">
              <span class="body-small">Totale:</span>
              <span class="body-medium-emphasized">
                {{ brogliaccio.importoTotale | currency:'EUR':'symbol':'1.2-2' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    } @empty {
      <span class="title-small">Nessun brogliaccio associabile</span>
    }
  </div>
</div>

<div class="selected-receipts-summary">
  <div class="selected-receipts-summary-top">
    <div class="selected-receipts-summary-row">
      <span class="body-small">Totale contanti:</span>
      <span class="body-small-emphasized">
        {{ totaleContantiSelezionati | currency:'EUR':'symbol':'1.2-2' }}
      </span>
    </div>

    <div class="selected-receipts-summary-row">
      <span class="body-small">Totale assegni:</span>
      <span class="body-small-emphasized">
        {{ totaleAssegniSelezionati | currency:'EUR':'symbol':'1.2-2' }}
      </span>
    </div>
  </div>

  <div class="selected-receipts-summary-divider"></div>

  <div class="selected-receipts-summary-bottom">
    <div class="selected-receipts-summary-row">
      <span class="body-large">Totale complessivo:</span>
      <span class="body-small-emphasized">
        {{ totaleBrogliacciSelezionati | currency:'EUR':'symbol':'1.2-2' }}
      </span>
    </div>
  </div>
</div>

<div class="new-draft-actions">
  <button
    matButton="filled"
    type="button"
    *uiCan="CAPS.distintaCrea"
    [disabled]="!almenoUnBrogliaccioIncluso || isSaving"
    (click)="creaDistinta()"
  >
    Crea distinta
  </button>
</div>
